const DEFAULT_TITLE = 'Healthxchange Devices'

export function routePageHead(pageTitle?: string | null, noIndex = false) {
  const title = pageTitle?.trim() || DEFAULT_TITLE
  return {
    meta: [
      { title },
      ...(noIndex ? [{ name: 'robots', content: 'noindex' }] : []),
    ],
  }
}
